/**
 * @author xyguo
 * @description 课堂助手-作业查看
 * @Date 2020/12/14
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateCofig, templateConfig} from './columns'
import ClassStudentAideInfo from './../classStudentAide/classStudentAideInfo'
import {modelUtils} from '@/utils'
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {WizModalUserIdentityShow} from '@/containers/common';

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs, WizSpin, WizModal} = component_tool;
let {Session} = utils_tool;

class ClassStudentHomeworkList extends WizContainer {

  componentName = 'ClassStudentHomeworkList';

  constructor(props) {
    super(props);
    this.state = {
      selectedClassResultRows: [],//选择的学员
      classStudentExamInfo:{}
    };
  }

  propsAndStateOnChange = {
  };

  

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织代码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '在职状态',
        field: 'jobStateName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '是否请假',
        field: 'leaveStateStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '是否参加',
        field: 'isAttendStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '提交时间',
        field: 'submitTime',
        width: 18,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '通过状态',
        field: 'passStr',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '标签',
        field: 'labelNames',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      {
        headerName: '成绩',
        field: 'score',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'center'},
        },
      },
      
      
    ]
    if (o['success']) {
      let data = o['data'];
      let dataNew = [];
      if(data){
        data.forEach(element => {
          element.jobStateName = element.jobState ===1 ? "在职" : element.jobState ===0 ?  "离职" : "" 
          element.leaveStateStr = element.leaveState ===1 ? "是" : element.leaveState ===0 ?  "否" : "" 
          element.isAttendStr = element.isAttend ===1 ? "是" : element.isAttend ===0 ?  "否" : "" 
          element.passStr = element.pass ===1 ? "通过" : element.pass ===0 ?  "未通过" : "" 
          dataNew.push(element);
        });
      }
      WizBrowserExport({
        title: '班级作业记录信息',
        sheetName: '班级作业记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataNew,
        filename: '班级作业记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }


  _render() {
    const {classStudentHomeworkLoading} = this.props;
    let record = this.props.location.record;
    const { classStudentExamInfo} = this.state;
    let classInfoId = null;
    let entityId = null;
    let classStudentHomeworkRecord = null;
    if (record) {
      Session.set('classStudentHomeworkRecord', record);
    }
    if (Session.get('classStudentHomeworkRecord')) {
      classStudentHomeworkRecord = Session.get('classStudentHomeworkRecord');
      classInfoId = classStudentHomeworkRecord.classId;
      entityId = classStudentHomeworkRecord.id;
    }
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedClassResultRows: rows,
          selectedRows: rows.length,
          data: new Date().getTime(),
          rows: rows
        });
      },
      _this: this,
      classInfoId,
    });
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      classInfoId,
      entityId,
      apiDataFormat: {
        exportClassStudentHomework: this._handleFile,
      },
    });
    
    return (
      <>
        <WizSpin tip={"加载中"} spinning={classStudentHomeworkLoading }>
          <ClassStudentAideInfo {...classStudentHomeworkRecord} />
          <WizCard title={'环节记录'}>
            <WizReduxTemplate  {..._reduxTemplateCofig} />
          </WizCard>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {classStudentHomework} = state;
  const load = modelUtils.getLoadingState(state, ['classStudentHomework']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ClassStudentHomeworkList);
